import { Machine } from "xstate";

const loginWithTokenMachine = Machine({
  id: "loginWithToken",
  initial: "idle",
  states: {
    idle: {
      on: {
        LOGIN: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "error",
      },
    },
    error: {
      type: "final",
    },
    success: {
      type: "final",
    },
  },
  on: {
    ERROR: "error",
  },
});

export default loginWithTokenMachine;
